
	import { Component, Vue } from 'vue-property-decorator';
	import FitstationSVG from '@/components/FitstationSVG.vue';
	import { Observer } from 'mobx-vue';
	import NotesButton from '@/components/NotesButton.vue';
	import Modal from '@/components/Modal.vue';
	import ShoeSizeModal from '@/components/ShoeSizeModal.vue';
	import ShoeSizePicker from '@/components/ShoeSizePicker.vue';
	import DesignInspectionButton from '@/components/DesignInspectionButton.vue';
	import Loading from '@/components/Loading.vue';
	import errorMessages from '@/assets/error-messages.json';
	import WeightInput from '@/components/WeightInput.vue';
	import HelpModal from '@/views/prescription/components/HelpModal.vue';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import { Patient } from '@/store/engine/openapi/generated';
	import UtilsStore from '@/store/utilsStore';

	@Observer
	@Component({
		components: {
			DualButtonModal,
			WeightInput,
			FitstationSVG,
			NotesButton,
			Modal,
			ShoeSizeModal,
			ShoeSizePicker,
			DesignInspectionButton,
			Loading,
			HelpModal
		},
		filters: {
			fixedLength(val: string) {
				if (val.length >= 43) {
					return val.slice(0, 40) + '...';
				} else {
					return val;
				}
			}
		}
	})
	export default class GetStartedView extends Vue {
		private settingDOB = true;
		private invalid = false;
		private errorMessages: any;
		// eslint-disable-next-line no-useless-escape
		private reg: RegExp = /\,|\<|\>|\:|\“|\“|\”|\"|\/|\\|\||\?|\*/;
		private showInfo = false;
		private settingPatient = false;
		private creatingPatientFlag = false;

		private missingPatientInformation() {
			return Boolean(
				!this.$state._patient.patientUIData.firstName ||
					!this.$state._patient.patientUIData.lastName ||
					!this.$state._patient.patientUIData.assignedToDoctor ||
					!this.$state._patient.patientUIData.weight.value
			);
		}

		get creatingPatient() {
			return this.creatingPatientFlag || this.settingPatient;
		}

		private buttonDisabled() {
			return this.missingPatientInformation() || this.creatingPatient;
		}

		async save() {
			this.creatingPatientFlag = true;
			if (!this.checkIfValid()) return;
			try {
				const patient = await this.$state._patient.createPatient();
				await this.$state._patient.updateMedicalProfile({ update: true });
				this.$state.doctor.patients?.unshift(patient);

				await this.$router.push('patients');
				location.reload();
			} catch (e) {
				this.creatingPatientFlag = false;
			} finally {
				this.$state.utils.addingPatient = false;
				this.creatingPatientFlag = false;
			}
		}

		async back() {
			this.patientRecall();
		}

		async activated() {
			this.validate();
			this.invalid = false;
			this.creatingPatientFlag = false;
			this.$forceUpdate();
		}

		private async startPrescriptionFlow() {
			this.settingPatient = true;
			this.$state._patient.patientUIData.firstName = this.$state._patient.patientUIData.firstName.trim();
			this.$state._patient.patientUIData.lastName = this.$state._patient.patientUIData.lastName.trim();
			this.$state._patient.patientUIData.patientID = this.$state._patient.patientUIData.patientID.trim();
			if (!this.checkIfValid()) {
				this.settingPatient = false;
				return;
			}
			try {
				if (!this.$state._patient.userRecordID) {
					await this.$state._patient.createPatient();
				} else {
					await this.next();
				}

				await this.$router.push(this.$route.query['reassign'] ? 'summary' : 'scan-settings');
			} catch (e) {
				this.creatingPatientFlag = false;
				console.error(e);
			} finally {
				this.settingPatient = false;
			}
		}

		private async next() {
			try {
				const id = this.$state._patient.userRecordID;
				const did = this.$state._patient.patientUIData.assignedToDoctor;
				await this.$engine.profile.updateUser(this.$state._patient.userRecordID, {
					firstName: this.$state._patient.patientUIData.firstName,
					lastName: this.$state._patient.patientUIData.lastName,
					gender: this.$state._patient.patientUIData.gender
				});
				await this.$engine.profile.updateUserOwner(id, did);
			} catch (e) {
				throw new Error(e);
			}
		}

		private patientRecall() {
			// this.$state.utils.addingPatient = false;
			this.$router.push('index');
		}

		private getDays(): number | void {
			if (this.$state._patient.patientUIData.birthDate.month != '' && this.$state._patient.patientUIData.birthDate.year != '') {
				const calcMonth = this.$state._patient.patientUIData.birthDate.month - 1;
				const shorterMonths = [1, 3, 5, 8, 10];
				if (calcMonth === 1) {
					if (this.$state._patient.patientUIData.birthDate.year % 4 == 0) {
						return 29;
					} else {
						return 28;
					}
				}
				if (shorterMonths.includes(calcMonth)) {
					return 30;
				}
				return 31;
			}
		}

		private checkSpecialCharacters() {
			// eslint-disable-next-line no-useless-escape
			const fullName = this.$state._patient.patientUIData.firstName + ' ' + this.$state._patient.patientUIData.lastName;
			const patientID = this.$state._patient.patientUIData.patientID;

			if (UtilsStore.unifiedValidatorsForInput(fullName) || UtilsStore.unifiedValidatorsForInput(patientID)) {
				this.$state.utils.pushMessage(this.errorMessages.snackbars.invalidCharacters);
				return false;
			}

			return true;
		}

		private checkBOD(): boolean {
			if (this.settingDOB) {
				if (
					this.$state._patient.patientUIData.birthDate.day == '' ||
					this.$state._patient.patientUIData.birthDate.month == '' ||
					this.$state._patient.patientUIData.birthDate.year == ''
				) {
					return false;
				}
				if (
					!(
						Number.isInteger(this.$state._patient.patientUIData.birthDate.day) &&
						Number.isInteger(this.$state._patient.patientUIData.birthDate.month) &&
						Number.isInteger(this.$state._patient.patientUIData.birthDate.year)
					)
				) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.onlyNumbers);
					return false;
				}
				if (this.$state._patient.patientUIData.birthDate.month <= 0 || this.$state._patient.patientUIData.birthDate.month > 12) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.incorrectMonths);
					return false;
				}
				if (this.$state._patient.patientUIData.birthDate.year < 1900) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.invalidYear);
					return false;
				}
				if (
					new Date(
						this.$state._patient.patientUIData.birthDate.year,
						this.$state._patient.patientUIData.birthDate.month - 1,
						this.$state._patient.patientUIData.birthDate.day
					).getTime() > new Date().getTime()
				) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.futureDate);
					return false;
				}
				if (!(this.$state._patient.patientUIData.birthDate.day > 0 && this.$state._patient.patientUIData.birthDate.day <= this.getDays())) {
					this.$state.utils.pushMessage(this.errorMessages.snackbars.incorrectDays);
					return false;
				}
			}
			return true;
		}

		private created() {
			this.errorMessages = errorMessages;
		}

		private validate() {
			if (
				this.$state._patient.patientUIData.birthDate.day != '' ||
				this.$state._patient.patientUIData.birthDate.month != '' ||
				this.$state._patient.patientUIData.birthDate.year != ''
			) {
				this.settingDOB = true;
			} else {
				this.settingDOB = false;
			}
		}

		private validateInput(e) {
			const res = UtilsStore.unifiedValidatorsForInput(e.srcElement._value);
			if (res) {
				this.$state._patient.patientUIData.firstName = UtilsStore.removeInvalidCharactersForInput(this.$state._patient.patientUIData.firstName);
				this.$state._patient.patientUIData.lastName = UtilsStore.removeInvalidCharactersForInput(this.$state._patient.patientUIData.lastName);
				this.$state._patient.patientUIData.patientID = UtilsStore.removeInvalidCharactersForInput(this.$state._patient.patientUIData.patientID);
				this.$state._patient.patientUIData.zebraID = UtilsStore.removeInvalidCharactersForInput(this.$state._patient.patientUIData.zebraID);

				this.$state.utils.pushMessage(this.errorMessages.snackbars.invalidCharacters);
			}
		}

		private checkIfValid() {
			if (!this.checkSpecialCharacters()) {
				return false;
			}
			if (!this.checkBOD()) {
				this.$state.utils.pushMessage(this.errorMessages.snackbars.validBOD);
				this.invalid = true;
				return false;
			}
			this.invalid = false;
			return true;
		}
	}
